module.exports = __webpack_public_path__ + "static/img/p2.a67cb69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/p2.png
// module id = xZx0
// module chunks = 0 1